module.exports = __webpack_public_path__ + "static/img/GYWM-20.3968c59.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/aboutUs/GYWM-20.jpg
// module id = ch4c
// module chunks = 1